export default [
  {
    path: '/access-control',
    name: 'access-control',
    component: () => import('@/views/extensions/acl/AccessControl.vue'),
    meta: {
      action: 'read',
      resource: 'ADMIN_B2C',
    },
  },
  {
    path: '/settings',
    name: 'app-adm-settings-ecommerce',
    component: () => import('@/views/apps/settings/ecommerce/SettingsEcommecer.vue'),
    meta: {
      pageTitle: 'Config. E-commerce',
      action: 'read',
      resource: 'ADMIN_B2C',
    },
  },
  {
    path: '/comissions',
    name: 'app-adm-settings-comissions',
    component: () => import('@/views/apps/settings/comissions/SettingsComissions.vue'),
    meta: {
      pageTitle: 'Config. Comissões',
      action: 'read',
      resource: 'ADMIN_B2C',
    },
  },
  {
    path: '/parcelas',
    name: 'app-adm-parcelas',
    component: () => import('@/views/apps/settings/parcelas/SettingsParcelas.vue'),
    meta: {
      pageTitle: 'Config. Parcelas',
      action: 'read',
      resource: 'ADMIN_B2C',
    },
  },
]
